import React from "react";
import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Image } from 'react-bootstrap';

const logo = require('./../../assets/images/logo-badge.png');

export default function ForgotPassword() {
   const [sendMail, setSendMail] = useState(false);
   
  return (
   <Container>
      <Row className="section mobile-bg align-items-center justify-content-center py-3">
         <Col sm={12} className="py-3">
            { sendMail ?
               <Card className="card-login">
                  <Card.Body>
                     <div className="auth-logo">
                        <Image src={logo}/>
                     </div>
                     <h3 className="fw-bold text-center mt-5 mb-3">
                        Permintaan Reset Kata Sandi 
                        Berhasil Dikirimkan!
                     </h3>
                     <div className="text-secondary text-center mb-4">
                        Email untuk penggantian kata sandi sudah dikirimkan. Periksa kotak masuk email kamu untuk melanjutkan proses ganti kata sandi!
                     </div>
                     <div className="d-grid gap-2 mt-5 px-3 mb-3">
                        <Button className="rounded-pill p-3" variant="success" type="submit"  onClick={()=>setSendMail(!sendMail)}>
                           OK
                        </Button>
                     </div>
                  </Card.Body>
               </Card> : 
               <Card className="card-login px-3">
                  <Card.Body>
                     <div className="auth-logo">
                        <Image src={logo}/>
                     </div>
                     <h3 className="fw-bold text-center mt-5 mb-3">Lupa Kata Sandi</h3>
                     <div className="text-secondary text-center mb-4">
                        Masukkan alamat email yang telah terdaftar untuk mereset kata sandi
                     </div>
                     <Form>
                        <Form.Group controlId="formBasicEmail">
                           <Form.Label className="mb-2">Email</Form.Label>
                           <div className="position-relative">
                              <Form.Control type="text" placeholder="Masukan email terdaftar" />
                              <Form.Text className="input-icon">
                                 <i className="ph-envelope text-muted"></i>
                              </Form.Text>
                           </div>
                           {/* <Form.Text className="text-muted">
                              We'll never share your email with anyone else.
                           </Form.Text> */}
                        </Form.Group>
                        <div className="d-grid gap-2 mt-4">
                           <Button className="btn-auth rounded-pill p-3" variant="success" type="submit"  onClick={()=>setSendMail(!sendMail)}>
                              KIRIMKAN
                           </Button>
                        </div>
                     </Form>
                  </Card.Body>
               </Card>

            }
         </Col>
      </Row>
   </Container>
  );
}